<template>
    <div class="our-apps-view">
        <!-- <responsive-burger-menu   v-bind:MenuItems="MenuItems" /> -->
        <return-menu  />
        <!-- home page view , each <section> must be a layout component -->
        <landing-intro-secondary v-bind:LandingIntroData="LandingIntroData" />
        <ExecutiveSummary  v-bind="ExecutiveSummaryData" />

        
        <our-app-sliders />
        <contact-us v-bind="ContactUsData" />
         
        <FooterLayout />
    
    </div>
</template>

<script>
import ReturnMenu from '@/components/ui/ReturnMenu'
// import ResponsiveBurgerMenu from '@/components/ui/ResponsiveBurgerMenu'
import LandingIntroSecondary from '@/components/layout/LandingIntroSecondary'
import ExecutiveSummary from '@/components/layout/ExecutiveSummary'
import OurAppSliders from '@/components/layout/OurAppSliders'
import ContactUs from '@/components/layout/ContactUs'
import FooterLayout from '@/components/layout/Footer'

export default {
  components: {
    ReturnMenu,
    LandingIntroSecondary,
    ExecutiveSummary,
    OurAppSliders,
    ContactUs,
    FooterLayout
  },
   data(){
        return {
            MenuItems:[
                {
                    linkID:1,
                    linkName:'Home',
                    linkNameLocation:'#Home',
                    isCurrentSection:true,
                    linkActive:true
                },
                {
                    linkID:2,
                    linkName:'About Us',
                    linkNameLocation:'#ExecutiveSum',
                    isCurrentSection:false,
                    linkActive:true
                },
                {
                    linkID:3,
                    linkName:'Group Of Companies',
                    linkNameLocation:'#GroupOfCompanies',
                    isCurrentSection:false,
                    linkActive:true
                },
                {
                    linkID:4,
                    linkName:'Board Of Directors',
                    linkNameLocation:'#BoardOfDirectors',
                    isCurrentSection:false,
                    linkActive:true
                },
                {
                    linkID:5,
                    linkName:'Keeping You Safe',
                    linkNameLocation:'#KeepingYouSafe',
                    isCurrentSection:false,
                    linkActive:true
                },
                {
                    linkID:6,
                    linkName:'Our Mobile Apps',
                    linkNameLocation:'#OurMobileApps',
                    isCurrentSection:false,
                    linkActive:true
                },
                {
                    linkID:7,
                    linkName:'Our Call Center',
                    linkNameLocation:'#OurCallCenter',
                    isCurrentSection:false,
                    linkActive:true
                },
                {
                    linkID:8,
                    linkName:'Contact Us',
                    linkNameLocation:'#ContactUs',
                    isCurrentSection:false,
                    linkActive:true
                }
            ],
            LandingIntroData:{
                NameLocation:'#Top',
                BackgroundClass:'--our-apps',
                HeadingText:'Our Mobile Apps ',
                Btn:'',
                BtnState: false,
                ShowVideo:false
            },
            ExecutiveSummaryData:{
                NameLocation:'#ExecutiveSum',
                Title:'We breathe new life into technology',
                TitleClass:'--tert',
                LeadText:'',
                Content:'Global Choices provides personalised mobile app solutions as part of all our programmes in the drive for technology innovation. We have successfully developed 59 App\'s with our development partners, across multiple industries to suit a variety of audiences. We also develop using responsive design to ensure one web asset can be used by a wide variety of audiences. We produce native app\'s as well as web app\'s to deliver on client requirements. We use customised video to differentiate our route to market to launch new technology solutions that will ensure high uptake and utilisation.</br></br>To stay ahead of competition, insurers must offer superior experiences for their clients. This requires a total experience (TX) strategy which combines multi-experience (MX), customer experience (CX), employee experience (EX) and user experience (UX). TX focuses on how a policyholder interacts with their insurer, from the first contact all the way up to present day interactions.</br></br>Let Global Choices add value to your business and breathe new life into technology innovation and communication.'
            },
            ContactUsData:[{
                NameLocation:'ContactUs',
                items: ['Client Service', 'Finance', 'Resolutions', 'Procurement', 'Medical Desk']
            }] 
        }
    }
}
</script>

<style  lang="scss"   >
/*// .v-carousel{
    
//      -webkit-box-shadow: none; 
//      box-shadow: none; 
// }
// .v-window-item{
//     width:150px;
//     margin: 0 auto;
    
//  }*/

 
</style>